<div *ngIf="data != null && data.length > 0">
	<br/>
	<input id="RemoveZeroes" type="checkbox" [(checked)]="removeZeroes" (change)="onRemoveZeroesClicked()" /><label for="RemoveZeroes">Remove Zeroes</label>
	<table class="table sortable-table">
		<tr>
			<th (click)="sortLexClick('Namespace')">Namespace <span *ngIf="sortColumnName == 'Namespace'" [ngClass]="sortOrderAscending ? 'arrow-up' : 'arrow-down'"></span></th>
			<th (click)="sortLexClick('Topic')">Topic <span *ngIf="sortColumnName == 'Topic'" [ngClass]="sortOrderAscending ? 'arrow-up' : 'arrow-down'"></span></th>
			<th (click)="sortLexClick('Subscription')">Subscription <span *ngIf="sortColumnName == 'Subscription'" [ngClass]="sortOrderAscending ? 'arrow-up' : 'arrow-down'"></span></th>
			<th (click)="sortNumericClick('DeadLetterMessageCount')">DeadLetter Messages <span *ngIf="sortColumnName == 'DeadLetterMessageCount'" [ngClass]="sortOrderAscending ? 'arrow-up' : 'arrow-down'"></span></th>
			<th (click)="sortNumericClick('ActiveMessageCount')">Active Messages <span *ngIf="sortColumnName == 'ActiveMessageCount'" [ngClass]="sortOrderAscending ? 'arrow-up' : 'arrow-down'"></span></th>
		</tr>
		<tr *ngFor="let d of filteredData">
			<td>{{d.Namespace}}</td>
			<td>{{d.Topic}}</td>
			<td>{{d.Subscription}}</td>
			<td>{{d.DeadLetterMessageCount}}</td>
			<td>{{d.ActiveMessageCount}}</td>
		</tr>
	</table>
</div>